import { Injectable, Injector } from '@angular/core';
import { BaseState } from 'src/app/common/base/base.state'; import { Action, Selector, State, StateContext } from '@ngxs/store';
import { ReviewsCreate, ReviewsDelete, ReviewsRefresh, ReviewsRefreshById, ReviewsUpdate } from './reviews.action';
import { ReviewsService } from '../../reviews.service';
import { Review } from '../../reviews.models';

export class ReviewsStateModel {
  data: Review[] = [];
  // Distinguish an empty response from the store's pre-request default.
  loaded: boolean = false;
}

@State<ReviewsStateModel>({
  name: 'Reviews',
  defaults: {
    data: [],
    loaded: false,
  }
})
@Injectable()
export class ReviewsState extends BaseState {
  constructor(
    protected override injector: Injector,
    private _service: ReviewsService

  ) {
    super(injector);
  }

  @Selector()
  static read(state: ReviewsStateModel) {
    return state.data;
  }

  @Action(ReviewsRefresh)
  refresh({ patchState }: StateContext<ReviewsStateModel>) {
    patchState({ loaded: false });
    this._service.getReviews().subscribe(
      data => patchState({ data, loaded: true }),
      error => console.error(error)
    );
  }

  @Action(ReviewsRefreshById)
  refreshById({ getState, patchState }: StateContext<ReviewsStateModel>, { id }: ReviewsRefreshById) {
    this._service.getReviewById(id).subscribe(item => {
      const state = getState();
      const index = state.data.map(x => x.id).indexOf(id);
      if (index >= 0) {
        state.data.splice(index, 1);
      }
      patchState({
        data: [...state.data, item]
      });
    },
      error => console.error(error)
    );
  }

  @Action(ReviewsCreate)
  create({ getState, patchState }: StateContext<ReviewsStateModel>, { item }: ReviewsCreate) {
    const state = getState();
    const index = state.data.map(x => x.id).indexOf(item.id);
    if (index >= 0) {
      state.data.splice(index, 1);
    }
    patchState({
      data: [...getState().data, item]
    });
  }

  @Action(ReviewsUpdate)
  update({ getState, patchState }: StateContext<ReviewsStateModel>, { id, item }: ReviewsUpdate) {
    const state = getState();
    const index = state.data.map(x => x.id).indexOf(id);

    if (index >= 0) {
      state.data.splice(index, 1);
      patchState({
        data: [...state.data, item]
      });
    }
  }

  @Action(ReviewsDelete)
  delete({ getState, patchState }: StateContext<ReviewsStateModel>, { id }: ReviewsDelete) {
    patchState({
      data: getState().data.filter(x => x.id !== id)
    });
  }

}
